import { saveAs } from 'file-saver'
import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'

class AccountsAPI {
  public static async submit(type: 'create' | 'update', body: any) {
    const data = {
      _method: type === 'update' ? 'PUT' : 'POST',
      ...body,
    }
    const formData = FormsService.convertObjectToFormData(data)
    const config = { headers: FormsService.MULTIPART_HEADER }
    return (await $http.post(`/users/accounts/${type}`, formData, config)).data
  }

  public static async getProfile(accountId: number) {
    return (await $http.get(`users/accounts/profile/${accountId}`)).data
  }

  public static async addNotes(body: any) {
    return (await $http.put('users/accounts/note', body)).data
  }

  public static async impersonate(userId: number) {
    return (await $http.get(`users/fake-login/${userId}`)).data
  }

  public static async updateAddonsRequests(id: number, data: any) {
    return (await $http.post(`features/request/update/${id}`, data)).data
  }

  public static async updateAccountPackage(data: any) {
    return (await $http.post('users/accounts/package', data, { headers: { 'Content-Type': 'multipart/form-data' } })).data
  }

  public static async updateAccountFeatures(data: any) {
    return (await $http.post('users/accounts/features', data, { headers: { 'Content-Type': 'multipart/form-data' } })).data
  }

  public static async renewAccountSubscription(data: any) {
    return (await $http.post('subscription/renew', data, { headers: { 'Content-Type': 'multipart/form-data' } })).data
  }

  static async exportAccounts(filters: any) {
    const url = `/users/accounts/export?${FormsService.prepareQueryString(filters, true)}`
    const file = (await $http.get(url, { responseType: 'blob' })).data
    saveAs(file, 'accounts.xlsx')
  }

  public static async updateNotes(id: number, body: any) {
    return (await $http.post(`users/accounts/update-note/${id}`, body)).data
  }

  public static async getUtms() {
    return (await $http.get('/users/accounts/utms')).data
  }

  public static async switchAccount(body: any) {
    return (await $http.post('users/switch-account', body)).data
  }

  public static async deleteSub(body: any) {
    return (await $http.post('users/delete-sub', body)).data
  }

  public static async toggleNotifications(body: any) {
    return (await $http.put('users/toggle-notifications', body)).data
  }
}

export default AccountsAPI
